<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre5 sgc-2 sgc-15 sgc-44">PART I</p>
<p class="calibre1 dot1000a"></p>
<h1 class="calibre5 sgc-15 sgc-46">The Beginnings 1918–38</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?346f6d82